import React from 'react';
import { Col, Row } from 'react-bootstrap';
import calendarIcon from '../../../../assets/icons/png/3x/icn-calendar@3x.png';
import Icon, { ICONSIZE } from '../../../../../presentation/components/Icon';

const InfoBoxHeader = () => {
  return (
    <Row className="justify-content-center">
      <Col xs="auto" className="copy p-0 mt-3 pt-2">
        <Icon iconSrc={calendarIcon} alt="calendar" size={ICONSIZE.xxxlarge} />
      </Col>
    </Row>
  );
};

export default InfoBoxHeader;
